import { Box, Stack, Typography } from '@mui/material';

import { useTranslatedText } from 'hooks/useTranslatedText';
import { type Ticket } from 'restful/tickets';

import Icon from 'components/@icons/Icon';

interface Props {
  perks?: Ticket['perks'];
}

const TicketPerkList = ({ perks }: Props) => {
  const localize = useTranslatedText();

  if (!perks?.length) {
    return null;
  }

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      {perks.map((perk) => (
        <Box
          key={perk.id}
          sx={{
            display: 'flex',
            gap: 1,
          }}
        >
          <Icon name="Check" fontSize={16} color="global01.400" />
          <Typography
            variant="small"
            sx={{
              color: 'text.secondary',
            }}
          >
            {localize(perk.name)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default TicketPerkList;
